import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { theme } from '@styles/theme';
const statusColors = {
    success: {
        bg: `${theme.colors.status.success}20`,
        text: theme.colors.status.success,
        dot: theme.colors.status.success,
    },
    warning: {
        bg: `${theme.colors.status.warning}20`,
        text: theme.colors.status.warning,
        dot: theme.colors.status.warning,
    },
    error: {
        bg: `${theme.colors.status.error}20`,
        text: theme.colors.status.error,
        dot: theme.colors.status.error,
    },
    info: {
        bg: `${theme.colors.status.info}20`,
        text: theme.colors.status.info,
        dot: theme.colors.status.info,
    },
    neutral: {
        bg: theme.colors.background.tertiary,
        text: theme.colors.text.secondary,
        dot: theme.colors.text.muted,
    },
};
const sizeStyles = {
    sm: css `
    padding: 2px ${theme.spacing.xs};
    font-size: ${theme.typography.fontSize.xs};
  `,
    md: css `
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    font-size: ${theme.typography.fontSize.sm};
  `,
};
const Badge = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: ${({ $status }) => statusColors[$status].bg};
  color: ${({ $status }) => statusColors[$status].text};
  border-radius: ${theme.borderRadius.full};
  font-weight: ${theme.typography.fontWeight.medium};
  white-space: nowrap;

  ${({ $size }) => sizeStyles[$size]}
`;
const Dot = styled.span `
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ $status }) => statusColors[$status].dot};
`;
export function StatusBadge({ status, children, size = 'md', dot = false }) {
    return (_jsxs(Badge, { "$status": status, "$size": size, children: [dot && _jsx(Dot, { "$status": status }), children] }));
}
// Helper function to map prototype status to StatusType
export function getPrototypeStatusType(status) {
    switch (status) {
        case 'deployed':
            return 'success';
        case 'building':
        case 'deploying':
            return 'warning';
        case 'failed':
            return 'error';
        case 'registered':
        default:
            return 'neutral';
    }
}
// Helper function to map invitation status to StatusType
export function getInvitationStatusType(status) {
    switch (status) {
        case 'accepted':
            return 'success';
        case 'pending':
            return 'warning';
        case 'expired':
        case 'revoked':
            return 'error';
        default:
            return 'neutral';
    }
}
// Helper function to map health status to StatusType
export function getHealthStatusType(status) {
    switch (status) {
        case 'healthy':
            return 'success';
        case 'unhealthy':
            return 'error';
        case 'unknown':
        default:
            return 'neutral';
    }
}
